import React from 'react';
import Image from 'next/image';
import PdpValueTileModel from '../../../models/pdp-value-tile';
import styles from './pdp-value-tile.module.scss';

type Props = {
  data: PdpValueTileModel;
  openModal: (...args: any[]) => void;
  setModalContent?: (...args: any[]) => void;
};

const PdpValueTile = ({ data, openModal, setModalContent }: Props) => {
  if (!data) return <></>;

  const handleClick = () => {
    if (data.modalContent && setModalContent) {
      openModal(true);
      setModalContent(data.modalContent);
    }
  };

  return (
    <button
      className={styles['pdp-value-tile']}
      onClick={handleClick}
      type="button"
      {...(data.analyticsAttributes || {})}
      name="pdp-value-tile"
    >
      {data.icon && (
        <div className={styles['pdp-value-tile__icon-wrapper']}>
          <Image
            alt={data.icon.alt}
            className={styles['pdp-value-tile__icon']}
            height={data.icon.height}
            src={data.icon.src}
            width={data.icon.width}
          />
        </div>
      )}

      <div className={styles['pdp-value-tile__label-container']}>
        {data.label && (
          <p className={styles['pdp-value-tile__label']}>{data.label}</p>
        )}

        {data.modalContent && setModalContent && (
          <div className={styles['pdp-value-tile__info-button']}>
            {data.infoIcon && (
              <Image
                alt={data.infoIcon.alt}
                className={styles['pdp-value-tile__info-icon']}
                height={data.infoIcon.height}
                src={data.infoIcon.src}
                width={data.infoIcon.width}
              />
            )}
          </div>
        )}
      </div>
    </button>
  );
};

export default PdpValueTile;
